const Projects = [
  {
    id: 1,
    image: "./images/placementor.png",
    title: " Placementor",
    codebase: "https://github.com/Nikhil-Gupta-prog/Placementor_app.git ",
    technology: "MERN",
  },
  {
    id: 2,
    image: "./images/poll.webp",
    title: " Poll Counter",
    codebase: "https://github.com/Nikhil-Gupta-prog/Poll-Counter.git",
    technology: "MERN",
  },
  {
    id: 3,
    image: "./images/ecommerce.webp",
    title: "An E-commerece website",
    codebase:
      "https://github.com/Nikhil-Gupta-prog/Tshirt-Ecommerce-Website.git",
    technology: "MERN",
  },
  {
    id: 4,
    image: "./images/webscrap.webp",
    title: "Web scrapper for Crypto!",
    codebase: "https://github.com/Nikhil-Gupta-prog/webscraping.git",
    technology: "Node JS",
  },
  {
    id: 5,
    image: "./images/restro.webp",
    title: " Food Application",
    codebase:
      "https://github.com/Nikhil-Gupta-prog/food-delivery-Application.git",
    technology: "React JS, Firebase",
  },

  {
    id: 6,
    image: "./images/weath.webp",
    title: "Weather Application (Live)",

    codebase: "https://weatherinfo-60747.web.app/",
    technology: "React JS",
  },
  // {
  //   id: 6,
  //   image: "./images/ishika_portfolio.webp",
  //   title: "Web Portfolio (Live)",
  //   codebase: "https://ishikaportfolio.netlify.app/",
  //   technology: "Bootstrap",
  // },
];

export default Projects;
